import { OVERLAY } from "../constants";

export const myStore = () => {
  window.LIFE_CYCLE_EVENT_BUS.on("localization.my-store", ({ output }) => {
    const { cartAnalytics } = output || {};
    const { enableCheckNearbyStoreView } = cartAnalytics || {};
    if (enableCheckNearbyStoreView) {
      digitalData.event = digitalData.event || [];
      const ddoEvent = {
        category: {
          primaryCategory: OVERLAY,
        },
        eventInfo: {
          eventName: "store finder>stores list",
        },
      };
      digitalData.event.push(ddoEvent);
    }
  });
};
